import { BrowserRouter, Route, Routes, useLocation, useNavigate } from 'react-router';
import { useEffect } from 'react';
import HomePage from './pages/home/PageHome';
import ProductPage from './pages/product/PageProduct';
import CategoryPage from './pages/category/PageCategory';
import config from './config';

/**
 * WordPress route sync component
 * Syncs WordPress data attributes with react-router routes
 */
const WordPressRouteSync = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (!config.isWordPress) return;

    const rootElement = document.getElementById('ja-react-root');
    if (!rootElement) return;

    // Get the page type from data attributes
    const pageType = rootElement.getAttribute('data-type');
    const productId = rootElement.getAttribute('data-product-id');
    const categoryId = rootElement.getAttribute('data-category-id');

    // Build the target path based on data attributes
    let targetPath = '/';
    const params = new URLSearchParams();

    switch (pageType) {
      case 'product-details':
        targetPath = '/product';
        if (productId) params.set('id', productId);
        break;
      case 'product-category':
        targetPath = '/product-category';
        if (categoryId) params.set('id', categoryId);
        break;
      case 'featured-product-list':
      case 'related-product-list':
      case 'product-list':
      default:
        // Featured and related product lists are rendered as part of the home page
        targetPath = '/';
        break;
    }

    // Add language prefix if English
    const wpConfig = window.jaProgramSite || {};
    if (wpConfig.current_language === 'zh-hant') {
      targetPath = '/zh-hant' + targetPath;
    }

    // Build full path with query params
    const queryString = params.toString();
    const fullPath = queryString ? `${targetPath}?${queryString}` : targetPath;

    // Navigate to the appropriate route if not already there
    if (location.pathname + location.search !== fullPath) {
      navigate(fullPath, { replace: true });
    }
  }, [location, navigate]);

  return null;
};

const App = () => {
  // Get WordPress configuration if available
  const wpConfig = window.jaProgramSite || {};
  const lang = config.isWordPress && wpConfig.current_language === 'zh-hant' ? 'zh-hant' : 'en';

  // Always use routing, even in WordPress context
  return (
    <BrowserRouter basename={'/' + (config.siteUrl || '').split('/').filter(Boolean).splice(2).join('/')}>
      {/* {config.isWordPress && <WordPressRouteSync />} */}
      <Routes>
        <Route index element={<HomePage lang={lang} />} />
        <Route path="product" element={<ProductPage lang={lang} />} />
        <Route path="project" element={<ProductPage lang={lang} />} />
        <Route path="product-category" element={<CategoryPage lang={lang} />} />

        <Route path="en" element={<HomePage lang="en" />} />
        <Route path="en/product" element={<ProductPage lang="en" />} />
        <Route path="en/project" element={<ProductPage lang="en" />} />
        <Route path="en/product-category" element={<CategoryPage lang="en" />} />

        <Route path="zh-hant" element={<HomePage lang="zh-hant" />} />
        <Route path="zh-hant/product" element={<ProductPage lang="zh-hant" />} />
        <Route path="zh-hant/project" element={<ProductPage lang="zh-hant" />} />
        <Route path="zh-hant/product-category" element={<CategoryPage lang="zh-hant" />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;

